<!-- eslint-disable -->
<template>
  <div class="card bg-white border-0 rounded-3 mb-4 shadow-sm">
    <div class="card-body p-0">
      <div class="filter-container d-flex gap-3 mb-3">
        <!-- Year Selector -->
        <!--      <select v-model="listQuery.year" class="form-select w-auto" @change="handleFilter" aria-label="Выберите год">
                <option value="" disabled selected>Выберите год</option>
                <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
              </select>

              &lt;!&ndash; Month Selector &ndash;&gt;
              <select v-model="listQuery.month" class="form-select w-auto" @change="handleFilter" aria-label="Выберите месяц">
                <option value="" disabled selected>Выберите месяц</option>
                <option v-for="(month, index) in months" :key="index" :value="index + 1">{{ month.label }}</option>
              </select>-->
      </div>

      <div class="rating-cards-container">
        <div class="row g-4">
          <!-- First card -->
          <div class="col-md-4">
            <div class="card h-100">
              <div class="card-header d-flex justify-content-between align-items-center bg-light">
                <span class="fw-semibold">Рейтинг по количеству людей</span>
                <span @click="toggleSort('users_hired')" class="sort-icon cursor-pointer">
            <i :class="sortIcons.users_hired"></i>
          </span>
              </div>
              <div class="list-group list-group-flush scrollable-list" style="max-height: 300px; overflow-y: auto;">
                <div v-for="(item, index) in sortedRecruiters(listRecruitersSort1, 'users_hired')" :key="item.id"
                     class="list-group-item d-flex justify-content-between align-items-center py-2">
                  <span class="name text-truncate">{{ item.name }}</span>
                  <span class="value fw-bold badge bg-primary rounded-pill">{{ item.users_hired }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Second card -->
          <div class="col-md-4">
            <div class="card h-100">
              <div class="card-header d-flex justify-content-between align-items-center bg-light">
                <span class="fw-semibold">Рейтинг по количеству часов</span>
                <span @click="toggleSort('user_hours_hired')" class="sort-icon cursor-pointer">
            <i :class="sortIcons.user_hours_hired"></i>
          </span>
              </div>
              <div class="list-group list-group-flush scrollable-list" style="max-height: 300px; overflow-y: auto;">
                <div v-for="(item, index) in sortedRecruiters(listRecruitersSort2, 'user_hours_hired')" :key="item.id"
                     class="list-group-item d-flex justify-content-between align-items-center py-2">
                  <span class="name text-truncate">{{ item.name }}</span>
                  <span class="value fw-bold badge bg-success rounded-pill">{{ item.user_hours_hired }}</span>
                </div>
              </div>
            </div>
          </div>

          <!-- Third card -->
          <div class="col-md-4">
            <div class="card h-100">
              <div class="card-header d-flex justify-content-between align-items-center bg-light">
                <span class="fw-semibold">Рейтинг вакансий</span>
                <span @click="toggleSort('user_hours_hired')" class="sort-icon cursor-pointer">
            <i :class="sortIcons.user_hours_hired"></i>
          </span>
              </div>
              <div class="list-group list-group-flush scrollable-list" style="max-height: 300px; overflow-y: auto;">
                <div v-for="(item, index) in listVacancies" :key="item.id"
                     class="list-group-item d-flex justify-content-between align-items-center py-2">
                  <span class="name text-truncate">{{ item.title }}</span>
                  <span class="value fw-bold">
              <span class="badge bg-info rounded-pill">{{ item.total_candidates }}</span>
              <span class="mx-1">/</span>
              <span class="badge bg-warning text-dark rounded-pill">{{ item.total_hours }}</span>
            </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {fetchList, fetchPv, createCandidate, updateCandidate, deleteCandidate} from '@/api/candidate';
import {fetchListRecruiters} from '@/api/stats';
import {fetchPosition} from '@/api/position';

import {parseTime} from '@/utils';
import {saveBonuses} from '@/api/actualization';

const calendarTypeOptions = [
  {key: 'US', display_name: 'USA'},
];

const calendarTypeKeyValue = calendarTypeOptions.reduce((acc, cur) => {
  acc[cur.key] = cur.display_name;
  return acc;
}, {});

export default {
  name: 'candidatesTable',
  filters: {
    statusFilter(status) {
      const statusMap = {
        published: 'success',
        draft: 'info',
        deleted: 'danger',
      };
      return statusMap[status];
    },
    typeFilter(type) {
      return calendarTypeKeyValue[type];
    },
  },
  data() {
    return {
      vacancySortOrder: {
        total_candidates: 'asc',
        total_hours: 'asc',
      },
      vacancySortIcons: {
        total_candidates: 'el-icon-arrow-down', // Default icon
        total_hours: 'el-icon-arrow-down', // Default icon
      },
      sortOrder: {
        users_hired: 'asc',
        user_hours_hired: 'asc',
      },
      sortIcons: {
        users_hired: 'el-icon-arrow-down', // Default icon
        user_hours_hired: 'el-icon-arrow-down', // Default icon
      },
      tempBonus: {},
      fromVacancy: false,
      peselOption: 'no',
      peselOption2: 'no',
      userRole: '',
      position: null,
      checkedFields: ['name', 'phone', 'passport', 'pesel'],
      tableKey: 0,
      vacancies: [],
      recruiters: [],
      list: null,
      listRecruiters: null,
      listRecruitersSort1: null,
      listRecruitersSortCurrentMonth: null,
      listRecruitersSort2: [],
      sortedVacancies: [],
      filteredVacancies: [],
      listVacancies: null,
      total: 0,
      listLoading: true,
      listQuery: {
        isSortedByPeople: 0,
        isSortedByPeopleCurrentMonth: 0,
        isSortedByHours: 0,
        isSortedByVacancies: 0,
        isBlackList: 0,
        search: '',
        sort: '+id',
        status: null,
        year: new Date(),
        month: new Date().getMonth(),
        recruiterType: null
      },
      months: [
        {label: 'Январь'},
        {label: 'Февраль'},
        {label: 'Март'},
        {label: 'Апрель'},
        {label: 'Май'},
        {label: 'Июнь'},
        {label: 'Июль'},
        {label: 'Август'},
        {label: 'Сентябрь'},
        {label: 'Октябрь'},
        {label: 'Ноябрь'},
        {label: 'Декабрь'},
      ],
      recruiterTypes: [
        {label: 'UZ'},
        {label: 'USU'},
      ],
      calendarTypeOptions,
      sortOptions: [{label: 'ID Ascending', key: '+id'}, {label: 'ID Descending', key: '-id'}],
      statusOptions: ['published', 'draft', 'deleted'],
      showReviewer: false,
      formattedVacancies: [],
      temp: {
        name: '',
        vacancyCandidateId: null,
        is_pair: 0,
        pesel: '',
        recruiterId: ''
      },
      temp2: {
        name: '',
        vacancyCandidateId: null,
        gender: 3,
        is_pair: 1,
        pesel: '',
        recruiterId: ''
      },
      dialogFormVisible: false,
      dialogFieldsVisible: false,
      dialogBlackListVisible: false,
      dialogStatus: '',
      textMap: {
        update: 'Edit',
        create: 'Create',
      },
      dialogPvVisible: false,
      userBonusData: [],
      pvData: [],
      fields: [
        {label: 'Имя фамилия рекрутера', name: 'name', showAsMain: true},
        {label: 'Часы работы', name: 'recruiter_hours', showAsMain: true},
        {label: 'Часы кандидатов', name: 'candidates_hours', showAsMain: true},
        {label: 'Премия/бонус', name: 'bonus', showAsMain: true},
        {label: 'Зарплата', name: 'salary', showAsMain: true},
      ],
      rules: this.setRules(),
      downloadLoading: false,
    };
  },
  created: async function () {
    this.parseStatusFromUrl();
    this.checkBlackList();
    this.getList(this.listQuery);

    this.getListRecruiters(this.listQuery);

    const storedFields = localStorage.getItem('checkedFieldsCandidates');
    if (storedFields) {
      this.checkedFields = JSON.parse(storedFields);
    }

  },
  watch: {
    checkedFields: {
      handler(newValue) {
        localStorage.setItem('checkedFieldsCandidates', JSON.stringify(newValue));
      },
      deep: true
    }
  },
  methods: {
    toggleVacancySort(field) {
      this.vacancySortOrder[field] = this.vacancySortOrder[field] === 'asc' ? 'desc' : 'asc';
      this.updateVacancySortIcons(field);
    },
    updateVacancySortIcons(field) {
      this.vacancySortIcons[field] = this.vacancySortOrder[field] === 'asc' ? 'el-icon-arrow-down' : 'el-icon-arrow-up';
    },
    sortedVacancies(vacancies = []) {
      if (!Array.isArray(vacancies) || vacancies.length === 0) return []; // Prevents errors

      const filteredVacancies = vacancies.filter(vacancy =>
          vacancy.vacancy_candidates?.some(vacancyCandidate =>
              vacancyCandidate.candidates?.some(candidate => candidate.status === "Работает")
          )
      );

      console.log("Filtered vacancies:", filteredVacancies);

      // Sorting logic
      return [...filteredVacancies].sort((a, b) => {
        const totalCandidatesDiff = a.total_candidates - b.total_candidates;
        const totalHoursDiff = a.total_hours - b.total_hours;

        if (this.vacancySortOrder.total_candidates === 'asc') {
          if (totalCandidatesDiff !== 0) return totalCandidatesDiff;
        } else {
          if (totalCandidatesDiff !== 0) return -totalCandidatesDiff;
        }

        if (this.vacancySortOrder.total_hours === 'asc') {
          return totalHoursDiff;
        } else {
          return -totalHoursDiff;
        }
      });
    },
    toggleSort(field) {
      this.sortOrder[field] = this.sortOrder[field] === 'asc' ? 'desc' : 'asc';
      this.updateSortIcons(field);
    },
    updateSortIcons(field) {
      this.sortIcons[field] = this.sortOrder[field] === 'asc' ? 'el-icon-arrow-down' : 'el-icon-arrow-up';
    },
    sortedRecruiters(recruiters, field) {
      console.log(recruiters);
      if (!Array.isArray(recruiters) || recruiters.length === 0) return []; // Prevents errors
      const modifier = this.sortOrder[field] === 'asc' ? 1 : -1;
      return [...recruiters].sort((a, b) => (a[field] - b[field]) * modifier);
    },
    async getListRecruiters() {
      this.listLoading = true;

      this.listQuery.isSortedByPeople = 1;
      this.listQuery.isSortedByPeopleCurrentMonth = 0;
      this.listQuery.isSortedByHours = 0;
      this.listQuery.isSortedByVacancies = 0;
      const data1 = await fetchListRecruiters(this.listQuery);
      this.listRecruitersSort1 = data1.recruiters;

      this.listQuery.isSortedByPeople = 0;
      this.listQuery.isSortedByPeopleCurrentMonth = 1;
      this.listQuery.isSortedByHours = 0;
      this.listQuery.isSortedByVacancies = 0;
      const data1CurrentMonth = await fetchListRecruiters(this.listQuery);
      this.listRecruitersSortCurrentMonth = data1CurrentMonth.recruiters;


      this.listQuery.isSortedByPeople = 0;
      this.listQuery.isSortedByPeopleCurrentMonth = 0;
      this.listQuery.isSortedByHours = 1;
      this.listQuery.isSortedByVacancies = 0;
      const data2 = await fetchListRecruiters(this.listQuery);
      this.listRecruitersSort2 = data2.recruiters;


      this.listQuery.isSortedByPeople = 0;
      this.listQuery.isSortedByPeopleCurrentMonth = 0;
      this.listQuery.isSortedByHours = 0;
      this.listQuery.isSortedByVacancies = 1;
      const data3 = await fetchListRecruiters(this.listQuery);
      this.listVacancies = data3.sortedVacancies;


      this.listLoading = false;
    },
    storeBonuses() {
      saveBonuses(this.userBonusData).then(() => {
        this.$notify({
          title: 'Успешно',
          message: 'Успешно',
          type: 'success',
          duration: 2000,
        });
        window.location.reload();
      });
    },
    openHoursModal(user_id, userBonusData, additionalBonus = 0) {
      this.userBonusData = userBonusData;
      this.userBonusData.month = this.listQuery.month;
      this.userBonusData.year = this.listQuery.year;
      if (additionalBonus > 0) {
        this.userBonusData.initialBonus = additionalBonus;
        this.userBonusData.bonus = additionalBonus;
      } else {
        this.userBonusData.initialBonus = this.userBonusData.bonus;
      }
      this.dialogPvVisible = true;
    },
    formatDate2(date) {
      if (!date) return '';
      const options = {year: 'numeric', month: '2-digit', day: '2-digit'};
      return new Date(date).toLocaleDateString('ru-RU', options); // Format to 'YYYY-MM-DD'
    },
    formatDate(date) {
      if (!date) return '';
      const [year, month, day] = date.split('-');
      return `${day}-${month}-${year}`;
    },
    parseStatusFromUrl() {
      const path = this.$route.path;
      const regex = /status(\d+)/;
      const match = path.match(regex);
      if (match && match[1]) {
        this.listQuery.status = match[1];
      } else {
        this.listQuery.status = this.$route.query.status || null;
      }
      if (this.listQuery.status) {
        this.getList()
      }
    },
    checkBlackList() {
      const fullUrl = window.location.href;
      this.listQuery.isBlackList = fullUrl.includes('black-list') ? 1 : 0;
    },
    // isArrivalDateRequired() {
    //   return this.temp.status === 'Приезд';
    // },
    setRules() {
      return {
        name: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
        phone: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
        passport: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
        /*  pesel: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],*/
        comment: [{required: false, message: 'Обязательное поле', trigger: 'blur'}],
        gender: [{required: true, message: 'Обязательное поле', trigger: 'blur'}],
      };
    },
    async getList() {
      this.listLoading = true;
      const data = await fetchList(this.listQuery);
      if (data.redirect_to) {
        window.location.href = data.redirect_to;
      }
      this.list = data.candidates.items;
      this.total = data.candidates.total;
      this.vacancies = data.vacancies;
      this.userRole = data.userRole;
      this.formatVacancies(this.vacancies);
      this.recruiters = data.recruiters;
      if (this.recruiters.length === 1) {
        this.temp.recruiterId = this.recruiters[0].id;
        this.temp2.recruiterId = this.recruiters[0].id;
      }
      this.listLoading = false;
    },
    formatVacancies(data) {
      let options = [];
      this.vacancies.forEach(vacancy => {
        vacancy.vacancy_candidates.forEach(candidate => {
          options.push({
            label: `${vacancy.title}/${candidate.position}`,
            value: candidate.id
          });
        });
      });
      this.formattedVacancies = options;
    },
    handleFilter() {
      this.listQuery.page = 1;
      this.getListRecruiters();
    },
    resetTemp() {
      this.temp = {};
    },
    handleCreate(fromVacancy = false) {
      if (!fromVacancy) {
        this.resetTemp();
      }
      this.dialogStatus = 'create';
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate();
      });
    },
    handleBlackList() {
      this.dialogBlackListVisible = true;
    },
    createData() {
      if (this.temp.status === 'Приезд' && !this.temp.arrivalDate) {
        alert('Введите дату приезда');
        return
      }
      if (this.peselOption === 'yes' && this.temp.pesel === '') {
        alert('Введите pesel');
        return
      }
      if (this.peselOption2 === 'yes' && this.temp.pesel2 === '') {
        alert('Введите pesel для пары');
        return
      }
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          createCandidate(this.temp).then(() => {
            if (this.temp.gender === 3 && this.temp2.name !== '') {
              createCandidate(this.temp2).then(() => {
                console.log('pair created');
              });
            }
            this.list.unshift(this.temp);
            this.dialogFormVisible = false;
            this.$notify({
              title: 'Успешно',
              message: 'Успешно',
              type: 'success',
              duration: 2000,
            });
            if (this.fromVacancy) {
              window.location.href = '/#/candidates/status1';
            } else {
              window.location.reload();
            }
          });
        }
      });
    },
    handleUpdate(row) {
      this.temp = Object.assign({}, row); // copy obj
      this.dialogStatus = 'update';
      this.dialogFormVisible = true;
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate();
      });
    },
    updateData() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          const tempData = Object.assign({}, this.temp);
          updateCandidate(tempData).then(() => {
            for (const v of this.list) {
              if (v.id === this.temp.id) {
                const index = this.list.indexOf(v);
                this.list.splice(index, 1, this.temp);
                break;
              }
            }
            this.dialogFormVisible = false;
            this.$notify({
              title: 'Успешно',
              message: 'Данные успешно изменены',
              type: 'success',
              duration: 2000,
            });
            let redirect = '1';
            if (this.temp.status === 'Работает') {
              redirect = '3';
            } else if (this.temp.status === 'Не работает') {
              redirect = '4';
            }
            window.location.href = '/#/candidates/status' + redirect;
          });
        }
      });
    },
    handleDelete(row) {
      if (confirm('подтвердить удаление')) {
        deleteCandidate(row).then(() => {
          this.$notify({
            title: 'Успешно',
            message: 'Удалено',
            type: 'success',
            duration: 2000,
          });
          const index = this.list.indexOf(row);
          this.list.splice(index, 1);
        });
      }
    },
    handleFetchPv(pv) {
      fetchPv(pv).then(response => {
        this.pvData = response.data.pvData;
        this.dialogPvVisible = true;
      });
    },
    handleUpload() {
      this.$refs['excel-upload-input'].click();
    },
    handleClick(e) {
      const file = e.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = e => {
        this.temp.image = e.target.result;
      };
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        if (j === 'timestamp') {
          return parseTime(v[j]);
        } else {
          return v[j];
        }
      }));
    },
    handleDownload() {
      /*     this.downloadLoading = true;
           import('@/vendor/Export2Excel').then(excel => {
             const tHeader = ['Имя фамилия рекрутера', 'Количество часов', 'Количество часов кандидатов', 'Премия/бонус', 'Зарплата'];
             const filterVal = ['name', 'total_working_hours', 'user_hours_hired', 'bonus', 'salary'];
             const list = this.listRecruiters;
             const data = this.formatJson(filterVal, list);
             excel.export_json_to_excel({
               header: tHeader,
               data,
               filename: 'candidates',
               autoWidth: this.autoWidth,
               bookType: this.bookType,
             });
             this.downloadLoading = false;
           });*/
    },
    getSortMethod(fieldName) {
      return (a, b) => {
        let valA, valB;

        switch (fieldName) {
          case 'recruiter_hours':
            valA = parseFloat(a.total_working_hours);
            valB = parseFloat(b.total_working_hours);
            break;
          case 'bonus':
            valA = a.bonuses && a.bonuses[this.listQuery.month + '-' + new Date(this.listQuery.year).getFullYear()]
                ? parseFloat(a.bonuses[this.listQuery.month + '-' + new Date(this.listQuery.year).getFullYear()].bonus)
                : parseFloat(a.bonus);
            valB = b.bonuses && b.bonuses[this.listQuery.month + '-' + new Date(this.listQuery.year).getFullYear()]
                ? parseFloat(b.bonuses[this.listQuery.month + '-' + new Date(this.listQuery.year).getFullYear()].bonus)
                : parseFloat(b.bonus);
            break;
          case 'candidates_hours':
            valA = parseFloat(a.user_hours_hired);
            valB = parseFloat(b.user_hours_hired);
            break;
          case 'salary':
            valA = a.bonuses && a.bonuses[this.listQuery.month + '-' + new Date(this.listQuery.year).getFullYear()]
                ? parseFloat(a.bonuses[this.listQuery.month + '-' + new Date(this.listQuery.year).getFullYear()].salary)
                : parseFloat(a.salary);
            valB = b.bonuses && b.bonuses[this.listQuery.month + '-' + new Date(this.listQuery.year).getFullYear()]
                ? parseFloat(b.bonuses[this.listQuery.month + '-' + new Date(this.listQuery.year).getFullYear()].salary)
                : parseFloat(b.salary);
            break;
          default:
            return 0; // Handle other fields or default case
        }

        return valA - valB;
      };
    }
  },
};
</script>

<style scoped>
.rating-cards-container {
  margin: 1rem 0;
}

.card {
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: none;
}

.card-header {
  padding: 0.75rem 1.25rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}

.sort-icon {
  font-size: 1rem;
  color: #6c757d;
  transition: all 0.2s;
}

.sort-icon:hover {
  color: #0d6efd;
  transform: scale(1.1);
}

.cursor-pointer {
  cursor: pointer;
}

.list-group-item {
  transition: background-color 0.2s;
}

.list-group-item:hover {
  background-color: #f8f9fa;
}

.name {
  flex: 1;
  margin-right: 1rem;
}

.scrollable-list::-webkit-scrollbar {
  width: 6px;
}

.scrollable-list::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 10px;
}

.scrollable-list::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 10px;
}

.scrollable-list::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

@media (max-width: 768px) {
  .col-md-4 {
    flex: 0 0 100%;
    max-width: 100%;
  }
}
</style>

<!-- eslint-enable -->
